module.exports = __webpack_public_path__ + "87b4ca1.woff2";